import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable ,  throwError } from 'rxjs';

import { JwtService } from './jwt.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ApiService {
  constructor(
      private http: HttpClient,
      private jwtService: JwtService 
  ) {}

  private formatErrors(error: any) {
    return  throwError(error.error);
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(`${environment.base_url}${path}`, { params })
        .pipe(catchError(this.formatErrors));
  }
 

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(
        `${environment.base_url}${path}`,
        JSON.stringify(body)
    ).pipe(catchError(this.formatErrors));
  }  
  
  post(path: string, body: Object = {}): Observable<any> {
    return this.http.post(
        `${environment.base_url}${path}`,
        JSON.stringify(body)
    ).pipe(catchError(this.formatErrors));
  }
  
 
  qrpost(path: string, body: Object = {}): Observable<any> {
    return this.http.post(
        `${environment.base_url}${path}`, 
        JSON.stringify(body),{ responseType: 'text' }
    ).pipe( catchError(this.formatErrors));
  }
 
  delete(path): Observable<any> {
    return this.http.delete(
        `${environment.base_url}${path}`
    ).pipe(catchError(this.formatErrors));
  }
} 

